module.exports = __webpack_public_path__ + "img/item.9b8ddfee.png";